import { UTSAV_THEME } from "../components/Utsav/theme.config";

export const welcomeMessageTitle =
  "Together with our family and with the blessings of {grandfather} and {grandmother}";
export const welcomeMessageSubTitle =
  "We request the honor of your presence as we unite our lives in marriage";

export const BannerSection = {
  title: "OH, Hey!",
  msg1: "It seems the invitation you're looking for doesn't exist.",
  msg2: "But no worries! You can design your own wedding invitation in just few clicks.",
};

export const Amantrika_link = "https://amantrika.com";
export const Amantrika_Local_link = "http://localhost:3000/";

export const instagram_link =
  "https://www.instagram.com/theamantrika?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";
export const Email_link = "mailto:theamantrika@gmail.com";

export const Themes = {
  classicElegance: "classic-elegance",
  modernChic: "modern-chic",
  indianTouch: "indian-touch",
  eternalGrace: "eternal-grace",
  regalMuse: "regal-muse",
  timelessCharm: "timeless-charm",
  royalMahal: "royal-mahal",
  // Renamed in one place: components/Utsav/theme.config.js
  utsav: UTSAV_THEME.identifier,
};

export const Cloudinary_link = "https://res.cloudinary.com/dxedclcqu";
export const CloudinaryPathPrefix =
  "https://res.cloudinary.com/dxedclcqu/image/upload/";
export const CloudinaryPathPrefixVideo =
  "https://res.cloudinary.com/dxedclcqu/video/upload/";
export const JAIN = "jain";
